import React, { useRef, useEffect } from "react";
import styles from "./RubricFrame.module.scss";
import Header from "../header/Header";
import Question from "../question/Question";

const RubricFrame = ({ rubric, type, isPreview }) => {
  const containerRef = useRef(null);

  useEffect(() => {
    const handleScroll = (e) => {
      const container = containerRef.current;
      if (!container) return;

      const { scrollTop, scrollHeight, clientHeight } = container;
      const isAtTop = scrollTop === 0;
      const isAtBottom = Math.ceil(scrollTop + clientHeight) >= scrollHeight;

      if ((isAtTop && e.deltaY < 0) || (isAtBottom && e.deltaY > 0)) {
        e.preventDefault();
      }
      e.stopPropagation();
    };

    const container = containerRef.current;
    if (container) {
      container.addEventListener('wheel', handleScroll, { passive: false });
      
      return () => {
        container.removeEventListener('wheel', handleScroll);
      };
    }
  }, []);

  if (!rubric) {
    return null;
  }
  
  return (
    <div className={styles.contentContainer} ref={containerRef}>
      <Header type={type} element={rubric} isPreview={isPreview} />
      {rubric?.questions?.length > 0 && (
        <div className={styles.questionsList}>
          {rubric.questions.map((question) => {
            if (!question?.titleFr && !question?.titleEn && !question?.titleNl) {
              return null;
            }
            return (
              <Question
                key={question?.id}
                question={question}
                authors={rubric?.author || []}
                chain={rubric?.chain?.[0] || null}
                rubric={rubric}
                isPreview={false}
              />
            );
          })}
        </div>
      )}
    </div>
  );
};

export default RubricFrame;
